<button
  class="h-[2rem] w-full relative flex justify-center transition-all duration-300 ease-in-out gap-1 items-center border-0 border-transparent px-4 text-sm rounded-md overflow-hidden disabled:opacity-70"
  [ngClass]="loading() ? eLoadingColors[color()] : eColors[color()]"
  [disabled]="loading() || disabled() || timerCount()"
  [type]="type()"
  >
  <div
    #progressBar
    class="absolute w-full h-full {{
      eColors[color()]
    }} transition-all duration-300 ease-in-out transform z-10"
  ></div>
  <div
    id="F352C259-E843"
    class="relative z-20 flex items-center justify-center"
    [ngClass]="{ 'gap-1': iconName() && text() }"
    >

    @if (timerCount()) {
      <h1> {{ timerText() ?? ('COMPONENTS.BUTTON.TIMER_TEXT' | translate) }}
        {{ timerCount() }} {{ timerCount() > 1 ? ('COMPONENTS.BUTTON.TIMER_SECONDS' | translate ) : ('COMPONENTS.BUTTON.TIMER_SECOND' | translate) }}</h1>
    }

    @if (!timerCount()) {
      @if (iconName()) {
        <lib-hero-icons
          id="5A36E5E6-4AD6"
          [iconName]="iconName()"
          [size]="iconSize()"
          class="-my-2"
          />
      }
      @if (flatIcon()) {
        <i class="{{ flatIcon() }}"></i>
      }
      <span id="F5C6FD53-55A4" class="truncate">
        {{ text() }}
      </span>
    }
  </div>
</button>
